import { closest } from "../../functions";

jQuery(document).ready(function ($) {
    const phones = document.querySelectorAll('input[name="phonenumber"]');
    phones.forEach((input) => {
        const form = closest(input, 'form'),
            $form = $(form),
            $emailInput = $form.find('input[name="email"]'),
            $phoneInput = $form.find('input[name="phonenumber"]'),
            $monthInput = $form.find('input[name="date"]'),
            instance = window.intlTelInput(input, {
                initialCountry: 'lu',
                dropdownContainer: document.body,
                placeholderNumberType: "MOBILE",
                separateDialCode: true,
                preferredCountries: ["lu", "al", "ad", "at", "by", "be", "ba", "bg", "hr", "cz", "dk",
                    "ee", "fo", "fi", "fr", "de", "gi", "gr", "va", "hu", "is", "ie", "it", "lv",
                    "li", "lt", "mk", "mt", "md", "mc", "me", "nl", "no", "pl", "pt", "ro",
                    "ru", "sm", "rs", "sk", "si", "es", "se", "ch", "ua", "gb"],
                utilsScript: theme.themeUrl + "/build/vendor/js/intlTelInputUtils.js",
            });

        if (localStorage.getItem('_userEmail')) {
            $emailInput.val(localStorage.getItem('_userEmail'));
        }
        if (localStorage.getItem('_userMonth')) {
            $monthInput.val(localStorage.getItem('_userMonth'));
        }
        if (localStorage.getItem('_userPhone')) {
            instance.setNumber(localStorage.getItem('_userPhone').replace(')', ' ').replace('(', '+'));
        }

        if ($('#phonewithcode').val().length > 3) {
            let phone = $('#phonewithcode').val().replace(')', ' ').replace('(', '+');
            instance.setNumber(phone);
        }

        $('#phonewithcode').val('(' + instance.getSelectedCountryData().dialCode + ')' + $phoneInput.val());
        $('.iti__selected-flag').ready(function () {
            $phoneInput.on("open:countrydropdown", function () {
                $(input).on('countrychange', function () {
                    $('#phonewithcode').val('(' + instance.getSelectedCountryData().dialCode + ')' + $phoneInput.val());
                });
            });
            $phoneInput.on('input', function () {
                $('#phonewithcode').val('(' + instance.getSelectedCountryData().dialCode + ')' + $phoneInput.val());
            });
        });
    });
});
